module.exports = __webpack_public_path__ + "img/google.cc12e811.png";